import script from "./SecCtaBand.vue?vue&type=script&setup=true&lang=js"
export * from "./SecCtaBand.vue?vue&type=script&setup=true&lang=js"

import "./SecCtaBand.vue?vue&type=style&index=0&id=c4b42a6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4b42a6c"]])

export default __exports__